import { render, staticRenderFns } from "./aiDistinguish.vue?vue&type=template&id=df01bc12&"
import script from "./aiDistinguish.vue?vue&type=script&lang=js&"
export * from "./aiDistinguish.vue?vue&type=script&lang=js&"
import style0 from "./aiDistinguish.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_dev\\workspace_front\\aikl_v2_front_kcc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df01bc12')) {
      api.createRecord('df01bc12', component.options)
    } else {
      api.reload('df01bc12', component.options)
    }
    module.hot.accept("./aiDistinguish.vue?vue&type=template&id=df01bc12&", function () {
      api.rerender('df01bc12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/biz/aiDistinguish.vue"
export default component.exports